module.exports = __webpack_public_path__ + "static/media/marker.c8ef3213.png";